import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Layout as ALayout } from 'antd';
import { ContainerQuery } from '@postermywall/react-container-query';
import classNames from 'classnames';
import { withAuth0 } from '@auth0/auth0-react';

const query = {
	'screen-xs': {
		maxWidth: 575,
	},
	'screen-sm': {
		minWidth: 576,
		maxWidth: 767,
	},
	'screen-md': {
		minWidth: 768,
		maxWidth: 991,
	},
	'screen-lg': {
		minWidth: 992,
		maxWidth: 1199,
	},
	'screen-xl': {
		minWidth: 1200,
		maxWidth: 1599,
	},
	'screen-xxl': {
		minWidth: 1600,
	},
};

function Layout(props) {
	const { children } = props;

	useEffect(() => {
		const staging = import.meta.env.MODE === 'staging';
		if (staging) {
			const favicon = document.getElementById('favicon');
			favicon.href = '$BPNYC_PUBLIC_URL/favicon_staging.ico';
			document.title = 'Thalo Admin (Staging)';
		}
	}, []);

	const layout = (
		<ALayout className="thaloAdminContainer">
			<ALayout>{children}</ALayout>
		</ALayout>
	);

	return (
		<ContainerQuery query={query}>
			{params => <div className={classNames(params)}>{layout}</div>}
		</ContainerQuery>
	);
}

const msp = () => ({});

export default withAuth0(connect(msp, null)(Layout));
